/* import __COLOCATED_TEMPLATE__ from './admin-projects-autocomplete.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

class AdminProjectsAutocomplete extends Component {
  @tracked internalValue = '';
  @tracked focus = false;

  #element = null;

  get value() {
    return this.focus
      ? this.internalValue
      : (this.args.value ?? '');
  }

  @action
  ref(element) {
    this.#element = element;
  }

  @action
  onFocus() {
    const value = this.value;

    if (this.internalValue !== value) {
      this.internalValue = value;
    }

    this.focus = true;
  }

  @action
  onBlur() {
    this.focus = false;
    this.args.onblur?.();
  }

  @action
  onChange({ id }) {
    this.args.onchange(id);
    this.#element.blur();
  }

  @action
  onKeyDown(e) {
    if (e.key !== 'Enter') {
      return;
    }

    const internalValue = this.internalValue.trim();

    if (!internalValue) {
      e.preventDefault();
      this.args.onchange(null);
      this.#element.blur();
    } else if (/^\d+$/.test(internalValue)) {
      e.preventDefault();
      this.args.onchange(internalValue);
      this.#element.blur();
    }
  }

  @action
  onInput(value) {
    this.internalValue = value;
    const trimmedValue = value.trim();
    const maybeName = (trimmedValue && !/^\d+$/.test(trimmedValue)) ? trimmedValue : null;
    this.args.oninput(maybeName);
  }
}

export default AdminProjectsAutocomplete;
